/** Client fit editor — agency multi-select + use cases VI/EN. */
import { useState } from 'react';

const AGENCY_OPTIONS = [
    { value: 'MPS', label: '🏛 MPS (Police)', color: '#3b82f6' },
    { value: 'Customs', label: '🛃 Customs', color: '#10b981' },
    { value: 'Border Guard', label: '🛡 Border Guard', color: '#f59e0b' },
    { value: 'Traffic Police', label: '🚦 Traffic Police', color: '#ef4444' },
    { value: 'MoND', label: '🎖 MoND (Military)', color: '#8b5cf6' },
    { value: 'Prison', label: '🔒 Prison', color: '#6b7280' },
    { value: 'Fire Dept', label: '🚒 Fire Dept', color: '#f97316' },
    { value: 'Others', label: '📋 Others', color: '#64748b' },
];

export default function ClientFitEditor({ clientFit, onChange }) {
    const agencies = clientFit?.agency_types || [];
    const useCasesEn = clientFit?.use_cases_en || '';
    const useCasesVi = clientFit?.use_cases_vi || '';
    const [tab, setTab] = useState('en');

    const toggleAgency = (val) => {
        const next = agencies.includes(val)
            ? agencies.filter(a => a !== val)
            : [...agencies, val];
        onChange({ ...clientFit, agency_types: next, use_cases_en: useCasesEn, use_cases_vi: useCasesVi });
    };

    const updateUseCases = (field, value) => {
        onChange({ ...clientFit, agency_types: agencies, [field]: value });
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="text-sm font-medium text-slate-200 block mb-2">Agency Types <span className="text-red-400">*</span></label>
                <div className="flex flex-wrap gap-2">
                    {AGENCY_OPTIONS.map(opt => {
                        const selected = agencies.includes(opt.value);
                        return (
                            <button
                                key={opt.value}
                                type="button"
                                onClick={() => toggleAgency(opt.value)}
                                className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors border ${selected
                                        ? 'text-white border-transparent'
                                        : 'bg-slate-800 text-slate-300 border-slate-600 hover:border-slate-500'
                                    }`}
                                style={selected ? { backgroundColor: opt.color } : {}}
                            >
                                {opt.label}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div>
                <div className="flex items-center gap-2 mb-2">
                    <label className="text-sm font-medium text-slate-200">Use Cases</label>
                    <div className="flex bg-slate-700 rounded-lg p-0.5">
                        <button type="button" onClick={() => setTab('en')}
                            className={`px-2 py-0.5 text-xs rounded ${tab === 'en' ? 'bg-amber-500/20 text-amber-400 font-semibold' : 'text-slate-400'}`}>EN</button>
                        <button type="button" onClick={() => setTab('vi')}
                            className={`px-2 py-0.5 text-xs rounded ${tab === 'vi' ? 'bg-amber-500/20 text-amber-400 font-semibold' : 'text-slate-400'}`}>VI</button>
                    </div>
                </div>
                <textarea
                    value={tab === 'en' ? useCasesEn : useCasesVi}
                    onChange={(e) => updateUseCases(tab === 'en' ? 'use_cases_en' : 'use_cases_vi', e.target.value)}
                    placeholder={tab === 'en' ? 'Describe use cases in English...' : 'Mô tả trường hợp sử dụng...'}
                    className="w-full bg-slate-800 border border-slate-600 rounded-lg p-3 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/50 min-h-[80px]"
                />
            </div>
        </div>
    );
}